import { useState, useEffect } from "react";
import BugReportNavigation from "./BugReportNavigation";
import BugReportQuestionArea from "./BugReportQuestionArea";
import * as theme from "../theme";
import Button from "@material-ui/core/Button";
import { getBrokerInformation } from "../store/broker";
import { useDispatch, useSelector } from "react-redux";
import {
  postToJira,
  bugModalClosed,
  getJiraStatus,
  successStatusModalOpened,
  errorStatusModalOpened,
} from "../store/components";
import { toast } from "react-toastify";
import { PossibleApiStatusValues } from "../store/helperfuncs";
import { formQuestions } from "./bugReportQuestions";
import translations from "../utils/translations";

// Used to enable/disable jiraStatus updates
var enableJiraStatusUpdates = null;

// Adapted from QFMainPane.jsx

const BugReportContent = () => {
  var [openFormId, setOpenFormId] = useState(0);
  var [form, setForm] = useState({});

  const handleHeaderClick = (formid) => {
    setOpenFormId(formid);
  };

  const setField = (field, value) => {
    setForm({
      ...form,
      [field]: value,
    });
  };

  const handleInput = (field, value) => {
    setField(field, value);
  };

  return (
    <div style={{ width: "100%", height: "100%" }}>
      <section
        className="text-center align-items-center"
        style={{
          display: "flex",
          height: "100%",
          position: "relative",
          backgroundColor: "#eef3f6",
        }}
      >
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: theme.SCALES.navigationWidth, height: "100%" }}>
            <BugReportNavigation
              formQuestions={formQuestions}
              openFormId={openFormId}
              onHeaderClick={handleHeaderClick}
            ></BugReportNavigation>
          </div>

          <div
            style={{
              height: "100%",
              width: `calc(100% - ${theme.SCALES.navigationWidth})`, // - ${theme.SCALES.qfHelpOrTipWidth}
              backgroundColor: theme.COLORS.tertiary_lightbackground,
              display: "flex",
              flexDirection: "column",
              position: "relative",
            }}
          >
            <div style={{ width: "100%", height: "90%" }}>
              <BugReportQuestionArea
                formQuestions={formQuestions}
                form={form}
                openFormId={openFormId}
                onInput={handleInput}
              ></BugReportQuestionArea>
            </div>
            <div
              style={{
                width: "100%",
                height: "10%",
                backgroundColor: theme.COLORS.help_tip,
              }}
            >
              <SubmitButton
                formQuestions={formQuestions}
                form={form}
                openFormId={openFormId}
              ></SubmitButton>
            </div>
          </div>
          {/* <div style={{ width: "10%" }}></div> */}
        </div>
      </section>
    </div>
  );
};

const SubmitButton = ({ formQuestions, form, openFormId }) => {
  const dispatch = useDispatch();
  const jiraStatus = useSelector(getJiraStatus);

  const brokerInformation = useSelector(getBrokerInformation);
  const brokerFirstName = brokerInformation.information.firstname;
  const languagepreference =
    brokerInformation?.information?.languagepreference || "en";
  const brokerLastName = brokerInformation.information.lastname;
  const brokerEmail = brokerInformation.information.user.email;
  const brokerBrokerageCode = brokerInformation.information.brokeragecode;

  const brokerFullName = brokerFirstName + " " + brokerLastName;

  const dateAndTime = new Date();
  const dd = String(dateAndTime.getDate()).padStart(2, "0");
  const mm = String(dateAndTime.getMonth() + 1).padStart(2, "0"); // January is 0!
  const yyyy = dateAndTime.getFullYear();
  const hours = dateAndTime.getHours();
  const minutes = String(dateAndTime.getMinutes()).padStart(2, "0");

  const date = dd + "/" + mm + "/" + yyyy;
  const time = hours + ":" + minutes;

  let payload = {
    fields: {
      summary: null,
      issuetype: {
        id: null,
        type: null,
      },
      project: {
        key: "QUOTEY",
      },
      description: {
        type: "doc",
        version: 1,
        content: [
          {
            type: "paragraph",
            content: [
              {
                text: `Date (dd/mm/yyyy): ${date}\nTime (24h): ${time}\nUser: ${brokerFullName}\nUser email: ${brokerEmail}\nUser's default brokerage: ${brokerBrokerageCode}\nPage URL: ${window.location.href}\n\n`,
                type: "text",
              },
            ],
          },
        ],
      },
    },
  };

  const handleEmptyForm = () => {
    toast("Please fill in at least one text field.");
  };

  const handleSubmit = () => {
    const currentForm = formQuestions[openFormId];
    // Use language preference for issue display
    payload.fields.summary = `${currentForm.issueDisplay[languagepreference]} – ${date} at ${time} - ${brokerFullName}`;

    if (payload.fields.summary.length > 255) {
      payload.fields.summary = `${currentForm.issueDisplay[languagepreference]} – ${date} at ${time}`;
    }

    payload.fields.issuetype.id = currentForm.issueID;
    payload.fields.issuetype.type = currentForm.issueType;

    switch (openFormId) {
      case 0:
        if (
          form.bugQuestion1 ||
          form.bugQuestion2 ||
          form.bugQuestion3 ||
          form.bugQuestion4
        ) {
          if (form.bugQuestion4 !== undefined) {
            payload.fields.summary = `${currentForm.issueDisplay[languagepreference]} – ${date} at ${time} - ${brokerFullName} - ${form.bugQuestion4}`;
            if (payload.fields.summary.length > 255) {
              payload.fields.summary = `${currentForm.issueDisplay[languagepreference]} – ${date} at ${time} - ${brokerFullName}`;
              if (payload.fields.summary.length > 255) {
                payload.fields.summary = `${currentForm.issueDisplay[languagepreference]} – ${date} at ${time}`;
              }
            }
          }
          payload.fields.description.content[0].content[0].text +=
            `${currentForm.questions.bugQuestion1.text[languagepreference]}: ${form.bugQuestion1}\n` +
            `${currentForm.questions.bugQuestion2.text[languagepreference]}: ${form.bugQuestion2}\n` +
            `${currentForm.questions.bugQuestion3.text[languagepreference]}: ${form.bugQuestion3}\n` +
            `${currentForm.questions.bugQuestion4.text[languagepreference]}: ${form.bugQuestion4}`;
        } else {
          handleEmptyForm();
          return;
        }
        break;
      case 1:
        if (form.featureQuestion1) {
          payload.fields.description.content[0].content[0].text += `${formQuestions[1].questions.featureQuestion1.text[languagepreference]}: ${form.featureQuestion1}`;
        } else {
          handleEmptyForm();
          return;
        }
        break;
      case 2:
        if (form.operationQuestion1) {
          payload.fields.description.content[0].content[0].text += `${formQuestions[2].questions.operationQuestion1.text[languagepreference]}: ${form.operationQuestion1}`;
        } else {
          handleEmptyForm();
          return;
        }
        break;
      case 3:
        if (form.insurerQuestion1) {
          payload.fields.description.content[0].content[0].text +=
            `${formQuestions[3].questions.insurerQuestion1.text[languagepreference]}: ${form.insurerQuestion1}\n` +
            `${formQuestions[3].questions.insurerQuestion2.text[languagepreference]}: ${form.insurerQuestion2}`;
        } else {
          handleEmptyForm();
          return;
        }
        break;
      case 4:
        if (
          form.questionQuestion1 ||
          form.questionQuestion2 ||
          form.questionQuestion3 ||
          form.questionQuestion4
        ) {
          payload.fields.description.content[0].content[0].text +=
            `${formQuestions[4].questions.questionQuestion1.text[languagepreference]}: ${form.questionQuestion1}\n` +
            `${formQuestions[4].questions.questionQuestion2.text[languagepreference]}: ${form.questionQuestion2}\n` +
            `${formQuestions[4].questions.questionQuestion3.text[languagepreference]}: ${form.questionQuestion3}\n` +
            `${formQuestions[4].questions.questionQuestion4.text[languagepreference]}: ${form.questionQuestion4}`;
        } else {
          handleEmptyForm();
          return;
        }
        break;
      default:
        return;
    }

    enableJiraStatusUpdates = true;
    dispatch(postToJira(payload));
  };

  const handleSuccessfulPost = () => {
    enableJiraStatusUpdates = false;
    dispatch(bugModalClosed());
    dispatch(successStatusModalOpened());
  };

  const handleUnsuccessfulPost = () => {
    enableJiraStatusUpdates = false;
    toast("Uh oh! Something went wrong. Please try again.");
  };

  useEffect(() => {
    if (
      jiraStatus === PossibleApiStatusValues.success &&
      enableJiraStatusUpdates === true
    ) {
      handleSuccessfulPost();
    } else if (
      jiraStatus === PossibleApiStatusValues.failed &&
      enableJiraStatusUpdates === true
    ) {
      handleUnsuccessfulPost();
    }
  }, [jiraStatus]);

  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-end",
        paddingLeft: theme.SCALES.letfRighMarginInQuestionArea,
        paddingRight: theme.SCALES.letfRighMarginInQuestionArea,
      }}
    >
      <NavigationButton
        bgColor={
          jiraStatus === PossibleApiStatusValues.loading
            ? theme.COLORS.tertiary_ligthindigo
            : theme.COLORS.secondary_skyblue
        }
        text={translations[languagepreference].submit}
        onClick={handleSubmit}
        disabled={jiraStatus === PossibleApiStatusValues.loading}
      />
    </div>
  );
};

const NavigationButton = ({
  onClick,
  text,
  bgColor,
  width = "15%",
  disabled,
}) => {
  const bkgColor = bgColor ? bgColor : "lightgray";
  return (
    <Button
      variant="contained"
      onClick={onClick}
      style={{
        color: "white",
        fontFamily: "GibsonSemiBd",
        fontSize: "1.5vmin",
        backgroundColor: bkgColor,
        width: width,
        borderRadius: "5%",
        height: "50%",
        letterSpacing: 1,
      }}
      disabled={disabled}
    >
      {text}
    </Button>
  );
};

export default BugReportContent;
